import type { CookieVariable } from "@/types/cookie-banner/styles/cookie-variables";

/**
 * Returns a CSS variable as a string.
 *
 * @param variable - The CSS variable to return.
 * @returns The CSS variable as a string.
 *
 * @example
 *
 * ```typescript
 * import { css } from 'cookies';
 *
 * const primaryColor = css('--cc-primary-color');
 * console.log(primaryColor); // Outputs: var(--cc-primary-color)
 * ```
 *
 * @see {@link CookieVariable} for a list of available CSS variables.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/var() var()} for more information on CSS variables.
 */
export function css(variable: CookieVariable | (string & {})): string {
  return `var(${variable})`;
}
